import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetPresignedDownloadURLForQuestionOptionsTemplateRPC } from "./getPresignedDownloadUrlForQuestionOptionsTemplateRPC";

export class GetPresignedDownloadURLForQuestionOptionsTemplateRPCClientImpl extends GetPresignedDownloadURLForQuestionOptionsTemplateRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetPresignedDownloadURLForQuestionOptionsTemplateRPC.Request): Promise<LeoRPCResult<GetPresignedDownloadURLForQuestionOptionsTemplateRPC.Response, GetPresignedDownloadURLForQuestionOptionsTemplateRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey/GetPresignedDownloadURLForQuestionOptionsTemplate",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetPresignedDownloadURLForQuestionOptionsTemplateRPC.ResponseDTO,
      GetPresignedDownloadURLForQuestionOptionsTemplateRPC.Errors.ErrorsDTO,
      GetPresignedDownloadURLForQuestionOptionsTemplateRPC.Response,
      GetPresignedDownloadURLForQuestionOptionsTemplateRPC.Errors.Errors
    >(
      response,
      "survey/GetPresignedDownloadURLForQuestionOptionsTemplate",
      GetPresignedDownloadURLForQuestionOptionsTemplateRPC.Response.fromDTO,
      GetPresignedDownloadURLForQuestionOptionsTemplateRPC.Errors.fromDTO
    );
  }
}
